import { ReactComponent as PadlockSVG } from '../icons/padlock.svg';

const NoAccess = () => {
  return (
    <main className="th-main">
      <section className="th-canvas">
        <section className="content-list">
          <div className="no-access">
            <PadlockSVG className="th-pages-placeholder" />
            <h2>Access to this page is limited</h2>
            <p>
              To gain access, please, contact administrators at
              support@sleepdoctor.me
            </p>
          </div>
        </section>
      </section>
    </main>
  );
};

export default NoAccess;
